const ROOT = '/patients';

const routes = {
  patients: () => ROOT,
  item: (id) => `${ROOT}/${id}`,
  create: () => `${ROOT}/add`
};

export default routes;
